import BaseButton from "Engine/base/ui/BaseButton";
import {TweenMax, Expo, Linear} from "gsap";
import Utils from "Engine/Utils";
import StatesManager from "Engine/base/states/StatesManager";

export default class SpinButton extends BaseButton {
    constructor(data, displayItemData) {
        super(data, displayItemData);

        this.incativeTintColor = 0xCCCCCC;

        this.init();
        this.createTweens();
    }

    init() {
        super.init();
        this.backgroundImage = this.getChildAt(0);
        this.image = this.getChildAt(1);
        this.image.pivot.set(this.image.width / 2, this.image.height / 2);
        this.image.x += this.image.width / 4;
        this.image.y += this.image.height / 4;
    }

    createTweens() {
        this.tween1 = TweenMax.to(this.image, 1, {rotation: '+=' + Utils.degToRad(360), ease:Expo.easeOut, paused:true});
        this.tween2 = TweenMax.to(this.image.scale, 0.15, {x: '-=' + 0.15, y: '-=' + 0.15, repeat:1, yoyo: true, ease:Linear.easeNone, paused:true});
    }

    onClick() {
        super.onClick();
        switch (StatesManager.currentState.stateData.name) {
            case 'idleState':
                this.tween1.play(0);
                break;
            default:
                this.tween2.play(0);
                break;
        }
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        if (value) {
            this.goToFrame(this.state === 'over' ? 2 : 1);
            this.interactive = true;
            this.buttonMode = true;
        } else {
            this.goToFrame(4);
            this.interactive = false;
            this.buttonMode = false;
        }
        this.children.forEach((child)=>{
            child.tint = this._enabled ? 16777215 : this.incativeTintColor;
        });
    }
}